import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { emaki_brand } from "../../utils/types/emaki_brand";
import { vignettePreview_template } from "./vignettePreview_template";
import { vignettePreview_helper } from "../../modules/vignettePreview_helper";

declare var ko: any;

export class vignettesView_template extends vnTemplate {
    protected vignettePreview: vignettePreview_template;
    protected vignettePreviewHelper: vignettePreview_helper;

    protected getTemplateHtml(): string {

        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <h3 class="form-title icon i-summary"  data-bind="text: name">Vignette</h3>
                    <div class="w-btn">
                        <!-- ko if: isBrandOwner() -->
                            <button data-bind="event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Vignette</button>
                        <!-- /ko -->
                    </div>
                </div>
                <div class="w-form-body">

                    <div class="form-body">

                        <strong class="form-sub-title no-margin">Code</strong>

                        <div class="form-group code-editor-tabs vignettes-edit-options">
                            <div class="reference-group">
                                <strong class="form-sub-title no-margin">References</strong>
                                <table class="list-action vignettes-edit" style="margin: 8px 0 10px 0;">
                                <thead>
                                    <tr>
                                        <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('tag') } }" style="cursor: pointer;">
                                            <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'tag', 'closed': activeReferenceSection() !== 'tag' }"></i></button>
                                            <label class="form-label">Tag References</label>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="visible: activeReferenceSection() === 'tag'">
                                <!-- ko foreach: tagDefaults -->
                                    <tr>
                                        <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                        <td><span type="button" data-bind="text: value"></span></td>
                                        <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                    </tr>
                                <!-- /ko -->
                                </tbody>

                                <thead>
                                    <tr>
                                        <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('article') } }" style="cursor: pointer;">
                                            <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'article', 'closed': activeReferenceSection() !== 'article' }"></i></button>
                                            <label class="form-label">Article References</label>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="visible: activeReferenceSection() === 'article'">
                                <!-- ko foreach: articleDefaults -->
                                    <tr>
                                        <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                        <td><span type="button" data-bind="text: value"></span></td>
                                        <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                    </tr>
                                <!-- /ko -->
                                </tbody>

                                <thead>
                                    <tr>
                                        <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('image') } }" style="cursor: pointer;">
                                            <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'image', 'closed': activeReferenceSection() !== 'image' }"></i></button>
                                            <label class="form-label">Image References</label>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="visible: activeReferenceSection() === 'image'">
                                <!-- ko foreach: imageDefaults -->
                                    <tr>
                                        <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                        <td><span type="button" data-bind="text: value"></span></td>
                                        <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                    </tr>
                                <!-- /ko -->
                                </tbody>

                                <thead>
                                    <tr>
                                        <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('video') } }" style="cursor: pointer;">
                                            <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'video', 'closed': activeReferenceSection() !== 'video' }"></i></button>
                                            <label class="form-label">Video References</label>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="visible: activeReferenceSection() === 'video'">
                                <!-- ko foreach: videoDefaults -->
                                    <tr>
                                        <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                        <td><span type="button" data-bind="text: value"></span></td>
                                        <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                    </tr>
                                <!-- /ko -->
                                </tbody>

                                <thead>
                                    <tr>
                                        <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('hub') } }" style="cursor: pointer;">
                                            <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'hub', 'closed': activeReferenceSection() !== 'hub' }"></i></button>
                                            <label class="form-label">Hub References</label>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="visible: activeReferenceSection() === 'hub'">
                                <!-- ko foreach: hubDefaults -->
                                    <tr>
                                        <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                        <td><span type="button" data-bind="text: value"></span></td>
                                        <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                    </tr>
                                <!-- /ko -->
                                </tbody>


                                <thead>
                                    <tr>
                                        <th colspan="3" data-bind="event: { click: function() { onClickToggleReferenceSection('brand') } }" style="cursor: pointer;">
                                            <button type="button" class="btn small"><i class="icon i-dropdown-simple" data-bind="css: { 'open': activeReferenceSection() === 'brand', 'closed': activeReferenceSection() !== 'brand' }"></i></button>
                                            <label class="form-label">Brand References</label>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody data-bind="visible: activeReferenceSection() === 'brand'">
                                <!-- ko foreach: brandDefaults -->
                                    <tr>
                                        <td><label for="" class="form-label" data-bind="text: key"></label></td>
                                        <td><span type="button" data-bind="text: value"></span></td>
                                        <td class="align-right"><button type="button" class="btn border only-icon icon i-copy" title="Copy reference" data-bind="event: { click: $parent.onClickCopyReference }, clickBubble: false"></button></td>
                                    </tr>
                                <!-- /ko -->
                                </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="form-group-row">
                            <div class="form-group">
                                <label for="" class="form-label">HTML</label>
                                <pre id="htmlEditor" data-bind="text: html"></pre>
                            </div>

                            <div class="form-group">
                                <label for="" class="form-label">CSS</label>
                                <pre id="cssEditor" data-bind="text: css"></pre>
                            </div>
                            <div class="form-group">
                                <label for="" class="form-label">JS</label>
                                <pre id="jsEditor" data-bind="text: js"></pre>
                            </div>
                        </div>

                        <div class="form-group" data-bind="visible: stylesheets().length > 0">
                            <label class="form-label">Shared Stylesheets</label>
                            <ul data-bind="foreach: stylesheets">
                                <li>
                                    <span data-bind="text: name"></span>
                                    <!-- ko if: slug -->
                                    <span class="form-text">(<span data-bind="text: slug"></span>)</span>
                                    <!-- /ko -->
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

                <div class="w-form-body">

                    <div class="form-body">

                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group">
                            ${ this.vignettePreview.getHtmlBuild() }
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    public setBindings(html, css, js = "") {
        this.getTemplateViewModel().html(html);
        this.getTemplateViewModel().css(css);
        this.getTemplateViewModel().js(js);
    }

    protected initPartial(): void {

        this.vignettePreviewHelper = new vignettePreview_helper(this.caller.getVnAppZone(), this.caller);
        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.vignettePreviewHelper);
        this.vignettePreview.setShowKeys(true);
        this.vignettePreviewHelper.initializeBrandDefaults();
    }

    protected getTemplateName(): string {

        return "vignettesView_template";
    }

    protected buildViewModel(): any {

        const self = this;

        return {
            brand: ko.observable(""),
            id: ko.observable(""),
            name: ko.observable(""),
            tagDefaults: ko.observableArray(vignettePreview_template.getTagDefaults()),
            articleDefaults: ko.observableArray(vignettePreview_template.getArticleDefaults()),
            imageDefaults: ko.observableArray(vignettePreview_template.getImageDefaults()),
            videoDefaults: ko.observableArray(vignettePreview_template.getVideoDefaults()),
            hubDefaults: ko.observableArray(vignettePreview_template.getHubDefaults()),
            brandDefaults: ko.observableArray(vignettePreview_template.getBrandDefaults()),
            html: ko.observable(""),
            css: ko.observable(""),
            js: ko.observable(""),
            stylesheets: ko.observableArray([]),
            isBrandOwner: ko.pureComputed(() => self.getIsBrandOwner()),
            brandOwner: ko.observable(null),
            activeReferenceSection: ko.observable(null),
            onClickToggleReferenceSection: this.onClickToggleReferenceSection.bind(this),
            onClickCopyReference: this.onClickCopyReference.bind(this),
            onClickCancel: function (data, event) {
                self.onClickCancel(data.id());
            },
            onClickEdit: function (data, event) {
                self.onClickEdit(data.id());
            }
        }
    }

    public getIsBrandOwner = (): boolean => {
        const vm = this.getTemplateViewModel();

        return (vm.brandOwner() && vm.brand())? vm.brandOwner().id == vm.brand() : false;
    }

    public onClickCancel(id) {
        this.caller.cancel(id);
    }

    public onClickEdit(id) {
        this.caller.edit(id);
    }

    public onClickToggleReferenceSection(section: string): void {
        const vm = this.getTemplateViewModel();
        vm.activeReferenceSection(vm.activeReferenceSection() === section ? null : section);
    }

    public onClickCopyReference(reference): void {
        if (vignettePreview_template.copyReferenceToClipboard(reference)) {
            this.caller.copyToClipboardAlert();
        }
    }

    public setBrandDefaults(brandReferences: any, labels: any): void {
        this.getTemplateViewModel().brandDefaults(vignettePreview_template.formatBrandReferences(brandReferences, labels));
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setName(name): void {
        this.getTemplateViewModel().name(name);
    }

    public setHtml(value): void {
        this.vignettePreview.setHtml(value);
        this.getTemplateViewModel().html(value);
    }

    public setCss(value): void {
        this.vignettePreview.setCss(value);
        this.getTemplateViewModel().css(value);
    }

    public setStylesheets(stylesheets): void {
        const list = Array.isArray(stylesheets) ? stylesheets : [];
        this.getTemplateViewModel().stylesheets(list);

        const sharedCss = list
            .map((stylesheet) => stylesheet && stylesheet.css ? stylesheet.css : '')
            .filter((css) => !!css)
            .join('\n\n');
        const vignetteCss = this.getTemplateViewModel().css() || '';
        const combined = [sharedCss, vignetteCss].filter((block) => !!block && block.trim() !== '').join('\n\n');
        this.vignettePreview.setCss(combined);
    }

    public setJs(value): void {
        this.vignettePreview.setJs(value);
        this.getTemplateViewModel().js(value);
    }

    public setBrand(brand: number): void {
        this.getTemplateViewModel().brand(brand);
    }

    public setBrandOwner(brand: emaki_brand): void {
        this.getTemplateViewModel().brandOwner(brand);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettesView_template.ts